<button
  #origin="cdkOverlayOrigin"
  #trigger
  class="relative h-full w-full bg-transparent px-4"
  cdk-overlay-origin
  data-cy="countryPrefixSelect"
  aria-haspopup="listbox"
  type="button"
  [attr.aria-labelledby]="id | awId: 'label'"
  [attr.aria-expanded]="panelOpen"
  [attr.aria-owns]="panelOpen ? (id | awId: 'panel') : null"
  [disabled]="disabled"
  (click)="onSetPanelOpen(true)"
>
  <div
    class="flex h-full w-full items-center gap-x-2 transition-all duration-300 ease-in"
  >
    <div class="flex h-full flex-1 items-center gap-x-2">
      @if (selectedCountry) {
        <aw-country-flag class="h-6 w-6" [country]="selectedCountry.code" />
        <span class="text-body-regular" data-testid="prefix">
          {{ selectedCountry.prefix }}
        </span>
      }
    </div>

    <button class="block px-1.5" type="button">
      <aw-icon
        class="flex h-4 w-4 text-black transition-all duration-200 ease-in"
        icon="chevron-down"
        [class.rotate-180]="panelOpen"
      />
    </button>
  </div>
</button>

<ng-template
  cdk-connected-overlay
  cdkConnectedOverlayLockPosition
  cdkConnectedOverlayHasBackdrop
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="panelOpen"
  [cdkConnectedOverlayWidth]="panelWidth"
  [cdkConnectedOverlayPositions]="positions"
  (backdropClick)="onSetPanelOpen(false)"
  (detach)="onSetPanelOpen(false)"
>
  <aw-container [attr.id]="id | awId: 'panel'">
    <ul
      class="mt-1 max-h-56 w-full overflow-hidden bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-base"
      tabindex="-1"
      aria-activedescendant="listbox-option-3"
      role="listbox"
      @panelOpen
      [attr.aria-labelledby]="id | awId: 'label'"
    >
      <div class="mt-2 px-2">
        <input
          #searchInput
          class="ctrl-border text-body-regular block w-full min-w-0 flex-1 px-3 py-2"
          data-testid="searchInput"
          data-cy="countryPrefixSearchInput"
          placeholder="Search"
          autocomplete="tel-country-code"
          type="text"
          (input)="onFilter($event)"
        />
      </div>

      <cdk-virtual-scroll-viewport
        class="aw-country-prefix-select-scroll-viewport mt-4"
        [style.height.px]="virtualViewportHeight"
        [style.width.px]="panelWidth"
        [itemSize]="itemHeight"
      >
        <aw-country-prefix-select-option
          *cdkVirtualFor="
            let item of items;
            let index = index;
            trackBy: trackByCode
          "
          [style.height.px]="itemHeight"
          [style.width.px]="panelWidth"
          data-cy="countryPrefixOption"
          role="option"
          [id]="id | awId: 'option' : index"
          [item]="item"
          [selected]="item.code === selectedCountry?.code"
          (click)="onOptionSelected(item)"
        />
      </cdk-virtual-scroll-viewport>
    </ul>
  </aw-container>
</ng-template>
